/**
 * Bonus Rules Engine
 * 
 * Applies bonus question rules to modify recommendations without affecting scores.
 */

/**
 * Bonus rule definitions
 */
const BONUS_RULES = [
  {
    id: 'B1_PROCESS',
    questionKey: 'bonus.b1',
    condition: (value) => value === 'Process',
    action: (recommendations) => {
      if (!recommendations.includes('EVOLVE')) {
        recommendations.push('EVOLVE');
      }
      return recommendations;
    },
    description: 'If B1 == "Process", add EVOLVE to recommendations'
  },
  {
    id: 'B4_FOUNDER_DRIVEN',
    questionKey: 'bonus.b4',
    condition: (value) => value === 'Founder-driven' || value === 'Top-down',
    action: (recommendations) => {
      if (!recommendations.includes('LEAD')) {
        recommendations.push('LEAD');
      }
      return recommendations;
    },
    description: 'If B4 == "Founder-driven" or "Top-down", add LEAD to recommendations'
  }
];

/**
 * Applies bonus rules to modify recommendations
 * @param {Object} bonusAnswers - Bonus question answers
 * @param {Array} baseRecommendations - Base recommendations from zone
 * @returns {Object} Modified recommendations and triggered rules
 */
export function applyBonusRules(bonusAnswers, baseRecommendations = []) {
  const recommendations = [...baseRecommendations];
  const triggeredRules = [];

  BONUS_RULES.forEach(rule => {
    const answer = bonusAnswers[rule.questionKey];
    
    if (answer !== undefined && rule.condition(answer)) {
      rule.action(recommendations);
      triggeredRules.push(rule.id);
    }
  });

  return {
    recommendations: [...new Set(recommendations)], // Remove duplicates
    triggeredRules
  };
}

/**
 * Gets base recommendations from zone
 * @param {string} zone - RED, YELLOW, or GREEN
 * @returns {Array} Base pillar recommendations
 */
export function getBaseRecommendations(zone) {
  switch (zone) {
    case 'RED':
      return ['LEAD', 'EVOLVE'];
    case 'YELLOW':
      return ['ALIGN', 'PERFORM'];
    case 'GREEN':
      return ['PERFORM'];
    default:
      return [];
  }
}

/**
 * Computes final recommendations with bonus rules
 * @param {string} zone - Assessment zone
 * @param {Object} bonusAnswers - Bonus question answers
 * @returns {Object} Final recommendations
 */
export function computeRecommendations(zone, bonusAnswers) {
  const baseRecommendations = getBaseRecommendations(zone);
  return applyBonusRules(bonusAnswers, baseRecommendations);
}
